export default __webpack_public_path__ + "ed13785.png";